module.exports = __webpack_public_path__ + "img/product3.56a90e3d.png";